var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"max-width":"1500px"},attrs:{"id":"docForm"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dense":"","flat":"","color":"secondary"}},[_c('v-toolbar-title',[_vm._v("Order Creation")])],1),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('editor')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }